<script setup lang="ts">
/* v8 ignore file */
import { useModalStore } from '@shared/model';

const config = useRuntimeConfig();
const router = useRouter();
const storeModal = useModalStore();
const goToProfile = () => {
  router.push("/lk/personal-information");
  storeModal.close();
}
const imgConfirmPhone = `${config.public.s3}/img/confirm_phone.png`;
</script>

<template>
  <div class="modelReg">
    <div class="modelReg__grid">
      <div class="modelReg__title">
        <h3>Чтобы оформить заказ</h3>
        <p>
          Надо перейти в раздел
          <button type="button" @click="goToProfile" class="modelReg__link">профиля</button>
          и потвердить номер телефона через телеграм аккаунт!
        </p>

        <img :src="imgConfirmPhone" alt="">
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.modelReg__link{
  @apply text-sky-500 underline cursor-pointer inline-block;
}
</style>

